import { doc, setDoc } from 'firebase/firestore';
import { db } from './firebase';

export const syncPublicProfile = (
  uid: string,
  fields: { penName?: string; avatar?: string; bio?: string; profileVisible?: boolean }
) => setDoc(doc(db, 'publicProfiles', uid), fields, { merge: true });